module.exports = __webpack_public_path__ + "static/media/YF101_3.ea1b5c2a.jpg";